// Module
var code = "<div data-moduleicon=\"fpd-icon-text-layers\" data-defaulttext=\"Text Layers\" data-title=\"modules.text_layers\"> <div class=\"fpd-scroll-area\"> <div class=\"fpd-list\"></div> </div> </div>";
// Exports
module.exports = code;